var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable eqeqeq */


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StyledAnimation from './StyledAnimation';
import noop from './utils/noop';
export default class StyledTransition extends Component {
  constructor() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super(props);

    this._isControlled = () => [true, false, 'enter', 'leave'].includes(this.props.state);

    this.onRest = props => {
      const {
        state
      } = this.state;

      if (state === 'enter') {
        this.props.didEnter(props);
      } else if (state === 'leave') {
        this.setState({
          currentChildren: null,
          lastChildren: null
        });
        this.props.didLeave(props);
      }

      this.props.onRest(props);
    };

    this.onStart = props => {
      const {
        state
      } = this.state;

      if (state === 'enter') {
        this.props.willEnter(props);
      } else if (state === 'leave') {
        this.props.willLeave(props);
      }

      this.props.onStart(props);
    };

    this.state = {
      state: '',
      lastChildren: null,
      currentChildren: null
    };
  }

  static getDerivedStateFromProps(props, state) {
    const willUpdateStates = {};

    if (props.children !== state.currentChildren) {
      willUpdateStates.lastChildren = state.currentChildren;
      willUpdateStates.currentChildren = props.children;

      if (props.children == null) {
        willUpdateStates.state = 'leave';
      } else {
        willUpdateStates.state = 'enter';
      }
    }

    if (props.state != null && props.state !== state.state) {
      willUpdateStates.state = props.state;
    }

    return willUpdateStates;
  }

  render() {
    const _a = this.props,
          {
      enter,
      leave
    } = _a,
          restProps = __rest(_a, ["enter", "leave"]);

    const {
      currentChildren,
      lastChildren
    } = this.state;

    const isControlled = this._isControlled();

    let children, type;
    let {
      state
    } = this.state;

    if (isControlled) {
      children = this.props.children;
      state = this.props.state;
    } else if (currentChildren == null && lastChildren == null) {
      return null;
    }

    if (state === 'enter') {
      type = enter;

      if (!isControlled) {
        children = currentChildren;
      }
    } else if (state === 'leave') {
      type = leave;

      if (!isControlled) {
        children = lastChildren;
      }
    }

    return /*#__PURE__*/React.createElement(StyledAnimation, Object.assign({}, restProps, {
      type: type,
      onStart: this.onStart,
      onRest: this.onRest
    }), children);
  }

}
StyledTransition.propTypes = {
  state: PropTypes.string,
  enter: PropTypes.string,
  leave: PropTypes.string,
  children: PropTypes.any,
  willEnter: PropTypes.func,
  didEnter: PropTypes.func,
  willLeave: PropTypes.func,
  didLeave: PropTypes.func,
  onStart: PropTypes.func,
  onRest: PropTypes.func
};
StyledTransition.defaultProps = {
  willEnter: noop,
  didEnter: noop,
  willLeave: noop,
  didLeave: noop,
  onStart: noop,
  onRest: noop
};